module.exports = __webpack_public_path__ + "static/media/game-Rdooropen.c3a4d60b.png";